import { IServicos } from '@/@types/Protocolo/Servicos';
import { api } from '@/services/api';
import { useEffect, useState } from 'react';

import { FormSolicitacoes } from '@/components/PagesComponents/FormSolicitacoes';

const SolicitacoesPosGraduacao = () => {
    const [servicos, setServicos] = useState<IServicos[]>([]);


    useEffect(() => {
        // busca os serviços de pós-graduação
        const url = `/protocolo/servicos/area/5cf693485e6e1adc78b0bdab`;

        const getServicosPorAreaId = async () => {
            await api.get(url)
                .then(response => {
                    setServicos(response.data);
                })
                .catch(err => {
                    console.log(err);
                })
        }

        getServicosPorAreaId();
    }, []);

    return (
        <>
            <h1>Pós-Graduação - Protocolo de solicitação de serviços</h1>

            <FormSolicitacoes servicos={servicos} tipoPagina='posgraduacao' />
        </>
    );
}

export { SolicitacoesPosGraduacao };